import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
  Navigate,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import ErrorPage from './routes/ErrorPage';
import Main from './routes/Main';
import Screenings from './routes/Screenings';
import Reference from './routes/Reference';
import ClimateChange from './routes/ClimateChange';
import Scroller from './components/Scroller';

// IMPORTANT: these routes must sit ABOVE :scrollerId. That route is a
// catch-all, so anything below it gets sent to the Scroller and fails to find
// a match in scrollers.json.
//
// /awards no longer exists as a page. It redirects, because the link may
// already be in circulation.
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<ErrorPage />}>
      <Route index element={<Main />} />
      <Route path="screenings" element={<Screenings />} />
      <Route path="climate-change" element={<ClimateChange />} />
      <Route path="reference" element={<Reference />} />
      <Route path="awards" element={<Navigate to="/screenings" replace />} />
      <Route path=":scrollerId" element={<Scroller />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
